import { render, staticRenderFns } from "./RichVerticalIndicator.vue?vue&type=template&id=28299528&scoped=true&"
import script from "./RichVerticalIndicator.vue?vue&type=script&lang=js&"
export * from "./RichVerticalIndicator.vue?vue&type=script&lang=js&"
import style0 from "./RichVerticalIndicator.vue?vue&type=style&index=0&id=28299528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28299528",
  null
  
)

component.options.__file = "RichVerticalIndicator.vue"
export default component.exports